// apps/frontend/src/components/ui/ToastRenderer.tsx
// 🎨 Rendu centralisé des toasts

import React from 'react';
import { useToast } from '../../hooks/useToast';
import ToastContainer from './ToastContainer';

export const ToastRenderer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  return <ToastContainer toasts={toasts} onRemoveToast={removeToast} />;
};
